import * as React from "react";
import { useTranslation } from "react-i18next";
import OverlayDropdownButton from "components/common/OverlayDropdownButton";
const MoreActions = ({ children = void 0, disabled = false }) => {
  const { t } = useTranslation("common");
  return /* @__PURE__ */ React.createElement(
    OverlayDropdownButton,
    {
      title: t("entity_table.more"),
      bsSize: "xsmall",
      buttonTitle: t("entity_table.more_actions"),
      disabled
    },
    children
  );
};
export default MoreActions;
